import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Play, Pause } from 'lucide-react';

const testimonialVideos = [
  { id: 1, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/4h2cmiox_default_533dc9a7-60a1-4650-b4e5-d3b6e3b57bd2_0.mp4' },
  { id: 2, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/onjtzy00_default_7347eb87-d985-49a1-b670-d066df66d274_0.mp4' },
  { id: 3, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/oyjfpyfy_default_29dec01c-c2ab-4f29-bf6c-343b3bd30493_0.mp4' },
  { id: 4, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/jhehms36_default_4e92778a-e82c-4108-b6ca-a8de5b7df9ab_0.mp4' },
  { id: 5, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/874ypxym_default_4b7a9a64-0802-43b9-b351-31678868e9b3_0.mp4' },
  { id: 6, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/uokekd03_default_650d51a6-8a41-445e-857c-d46f63915a17_0.mp4' },
  { id: 7, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/b23mu12v_default_1bd374ec-ac84-45db-99af-9b8a47aaf406_0.mp4' },
  { id: 8, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/1okxxyol_default_78c90d90-7601-486e-b275-b2d175e0df7d_0.mp4' },
  { id: 9, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/yfr9w0og_default_55711435-0176-452a-8f07-a0dfb23dbc10_0.mp4' },
  { id: 10, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/5jtejoye_default_3d86488c-9fec-4b55-9fe0-88c02a9ed11a_0.mp4' },
  { id: 11, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/cr0fi9zq_VID-20201028-WA0008.mp4' },
  { id: 12, type: 'video', src: 'https://customer-assets.emergentagent.com/job_a235b419-86b2-4667-9fd0-c39959dca4de/artifacts/80gbo00b_HairExtension%20training%20Academy%20Diane%20Shawe%20video%20%281%29.mp4' },
];

const VideoTestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const goToPrevious = () => {
    setIsPlaying(false);
    const newIndex = currentIndex === 0 ? testimonialVideos.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    setIsPlaying(false);
    const newIndex = currentIndex === testimonialVideos.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (index) => {
    setIsPlaying(false);
    setCurrentIndex(index);
  };

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const currentItem = testimonialVideos[currentIndex];

  return (
    <div className="video-testimonials-carousel" data-testid="video-testimonials-carousel">
      <div className="carousel-main">
        <button 
          className="carousel-nav-btn carousel-prev" 
          onClick={goToPrevious}
          aria-label="Previous testimonial"
          data-testid="carousel-prev-btn"
        >
          <ChevronLeft size={32} />
        </button>

        <div className="carousel-content">
          <div className="video-container">
            <video
              ref={videoRef}
              key={currentItem.id}
              src={currentItem.src}
              className="carousel-video"
              playsInline
              onEnded={() => setIsPlaying(false)}
              onClick={togglePlay}
              data-testid={`testimonial-video-${currentItem.id}`}
            />
            <button 
              className={`video-play-overlay ${isPlaying ? 'hidden' : ''}`}
              onClick={togglePlay}
              aria-label={isPlaying ? 'Pause video' : 'Play video'}
              data-testid="video-play-btn"
            >
              {isPlaying ? <Pause size={64} /> : <Play size={64} />}
            </button>
          </div>
          <p className="carousel-counter">
            {currentIndex + 1} / {testimonialVideos.length}
          </p>
        </div>

        <button 
          className="carousel-nav-btn carousel-next" 
          onClick={goToNext}
          aria-label="Next testimonial"
          data-testid="carousel-next-btn"
        >
          <ChevronRight size={32} />
        </button>
      </div>

      {/* Dot indicators */}
      <div className="carousel-dots">
        {testimonialVideos.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to testimonial ${index + 1}`}
            data-testid={`carousel-dot-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoTestimonialsCarousel;
